import { ObjectTypeEnum } from '../../_enums/object-type.enum';

export function isMnemonicEllipse(object: unknown): boolean {
    const typedObject = object as { type?: string; objectType?: string } | null | undefined;

    return typedObject?.type === 'ellipse' || typedObject?.objectType === ObjectTypeEnum.ellipse;
}

export function normalizeMnemonicEllipseDimensions(object: { rx?: number; ry?: number; set?: (key: string, value: number) => unknown }): void {
    if (!isMnemonicEllipse(object) || typeof object.set !== 'function') {
        return;
    }

    const rx = Number(object.rx) || 0;
    const ry = Number(object.ry) || 0;

    if (rx > 0) {
        object.set('rx', rx);
    }

    if (ry > 0) {
        object.set('ry', ry);
    }
}

export function buildMnemonicEllipseSizeUpdate(dimension: 'width' | 'height', value: number): Record<string, number> {
    return dimension === 'width' ? { rx: value / 2 } : { ry: value / 2 };
}
